import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import clipboardCopy from "clipboard-copy";
import { toastSuccess, toastFail } from "../config";

export const handleCopyText = async (text) => {
  try {
    await clipboardCopy(text);
  } catch (error) {
    console.error("Failed to copy text:", error);
    toast("Could not copy to clipboard", toastFail);
    return;
  }

  console.log("[handleCopyText] toastSUccess: ", toastSuccess);

  toast("Copied to clipboard", toastSuccess);
};

export function smartTimeAgo(sinceDate, compressed = false) {
  const hoursInSeconds = 60 * 60;
  const daysInSeconds = 60 * 60 * 24;
  const fortnightInSeconds = 60 * 60 * 24 * 14;

  // get seconds
  let seconds = Math.floor((new Date().getTime() - sinceDate.getTime()) / 1000);

  if (seconds < 0) {
    seconds = 0;
  }

  if (seconds < 61) {
    return seconds + (compressed ? "s" : " seconds") + " ago";
  }

  if (seconds > 60 && seconds < 3601) {
    return Math.floor(seconds / 60) + (compressed ? "m" : " mins") + " ago";
  }

  if (seconds > hoursInSeconds && seconds < daysInSeconds + 1) {
    return (
      Math.floor(seconds / hoursInSeconds) +
      (compressed ? "h" : " hours") +
      " ago"
    );
  }

  if (seconds > daysInSeconds && seconds < fortnightInSeconds + 1) {
    return (
      Math.floor(seconds / daysInSeconds) +
      (compressed ? "d" : " days") +
      " ago"
    );
  }

  return (
    "on" +
    sinceDate.toLocaleDateString("en-us", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  );
}

export function smartTimeAgo2(sinceDate, compressed = false) {
  const hoursInSeconds = 60 * 60;
  const daysInSeconds = 60 * 60 * 24;
  const fortnightInSeconds = 60 * 60 * 24 * 14;

  // get seconds
  let seconds = Math.floor((new Date().getTime() - sinceDate.getTime()) / 1000);

  if (seconds < 0) {
    seconds = 0;
  }

  if (seconds < 61) {
    return seconds + (compressed ? "s" : " seconds") + " ago";
  }

  if (seconds > 60 && seconds < 3601) {
    return Math.floor(seconds / 60) + (compressed ? "m" : " mins") + " ago";
  }

  if (seconds > hoursInSeconds && seconds < daysInSeconds + 1) {
    return (
      Math.floor(seconds / hoursInSeconds) +
      (compressed ? "h" : " hours") +
      " ago"
    );
  }

  if (seconds > daysInSeconds && seconds < fortnightInSeconds + 1) {
    return (
      Math.floor(seconds / daysInSeconds) +
      (compressed ? "d" : " days") +
      " ago"
    );
  }

  return sinceDate.toLocaleDateString("en-us", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
}

export const validateEmail = (e) => {
  if (!e) {
    return false;
  }

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return e.match(emailPattern) != null;
};

// must be 8 chars+, 1+ caps, 1+ number
export const validatePassword = (p) => {
  if (!p) {
    return false;
  }

  const chars = p.length > 7;

  const capitalLettersPattern = /[A-Z]+/g;
  const capitalMatches = p.match(capitalLettersPattern) != null;

  const numberPattern = /\d+/g;
  const numberMatches = p.match(numberPattern) != null;

  return chars && capitalMatches && numberMatches;
};
